<template>
  <v-row class="px-5 mb-2">
    <template v-if="mode !== 'inspection'">
      <v-btn
        v-if="
          (inspection.status === 'waiting_detection_result' ||
            inspection.status === 'received_detection_result' ||
            inspection.status === 'detection_error') &&
          post.recentOrder.status === 'under_detection'
        "
        class="my-2 font-weight-bold"
        block
        depressed
        disabled
      >
        コピーチェック確認中
      </v-btn>
      <v-btn
        v-if="post.recentOrder.status === 'under_inspection'"
        class="my-2 font-weight-bold"
        dark
        block
        depressed
        color="indigo"
        @click="startInspection(inspection.id)"
      >
        検収を開始する
      </v-btn>
      <v-btn
        v-if="inspection.status === 'under_inspection'"
        class="my-2 font-weight-bold"
        dark
        block
        depressed
        color="error"
        @click="overrideInspection(inspection.id)"
      >
        検収を上書きする
      </v-btn>
    </template>
    <template v-else-if="mode === 'inspection'">
      <v-btn
        class="my-2 font-weight-bold"
        dark
        depressed
        block
        color="success"
        @click="completeDialog = true"
      >
        校了とする
      </v-btn>
      <v-btn
        value="remand"
        class="my-2 font-weight-bold"
        dark
        depressed
        block
        color="error"
        @click="remandInspection"
      >
        差し戻す
      </v-btn>
      <v-row class="justify-end">
        <v-btn
          class="my-2 font-weight-bold"
          outlined
          small
          depressed
          color="error"
          @click="cancelInspection(inspection.id)"
        >
          検収をキャンセルする
        </v-btn>
      </v-row>
    </template>

    <v-dialog v-model="completeDialog" max-width="500">
      <InspectionCompletionForm
        @close-complete-dialog="completeDialog = false"
      />
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import InspectionCompletionForm from './InspectionCompletionForm'

export default {
  components: {
    InspectionCompletionForm
  },
  props: {
    inspection: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      completeDialog: false
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      mode: (state) => state.PostEditor.mode
    })
  },
  methods: {
    startInspection (inspectionId) {
      this.$store.dispatch('PostEditor/startInspection', { inspectionId })
    },
    overrideInspection (inspectionId) {
      this.$store.dispatch('PostEditor/overrideInspection', { inspectionId })
    },
    cancelInspection (inspectionId) {
      this.$store.dispatch('PostEditor/cancelInspection', { inspectionId })
    },
    remandInspection () {
      if (confirm('本当に差し戻しますか？')) {
        this.$store.dispatch('PostEditor/completeInspection', {
          result: 'remand'
        })
      }
    }
  }
}
</script>
